<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="规则名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <a-input v-model="model.name" placeholder="请输入规则名称"  ></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item label="预警类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="warnType">
              <j-multi-select-tag type="list_multi" v-model="model.warnType" dictCode="pre_send_type"  placeholder="请选择预警类型" />
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item label="时间单位" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="detectionUnit">
              <j-dict-select-tag type="radio" v-model="model.detectionUnit" dictCode="pre_time_type" @change="detectionUnitChange" placeholder="请选择时间单位" />
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item label="核酸时间配置" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="detectionTime">
              <a-input v-model="model.detectionTime" placeholder="请输入核酸时间配置" :suffix="timeType" style="width:50%" />
              
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item label="提前预警时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="beforeWarnTime">
              <j-dict-select-tag type="list" v-model="model.beforeWarnTime" dictCode="pre_before_hour" style="width:50%" placeholder="请选择提前预警时间" />
              <span style="position:absolute; right: 30px;">小时</span>
            </a-form-model-item>
          </a-col>
          <!-- 厂区区域 -->
            <!-- <a-col :span="24">
                <a-form-model-item label="厂区" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="factoryIdList">
                  <a-select 
                    allowClear
                    mode="multiple"
                    placeholder="请选择厂区"
                    v-model="model.factoryIdList"
                    :options="factoryOptions"
                    @change="factoryChange"
                    />
                </a-form-model-item>
            </a-col>

            <a-col :span="24">
                <a-form-model-item label="区域" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaIdList">
                  <a-select 
                    allowClear
                    mode="multiple"
                    placeholder="请选择区域"
                    v-model="model.areaIdList"
                    :options="areaOptions"
                    @change="areaChange"
                    />
                </a-form-model-item>
            </a-col>

            <a-col :span="24">
                <a-form-model-item label="楼栋" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="buildingIdList">
                  <a-select 
                    allowClear
                    mode="multiple"
                    placeholder="请选择楼栋"
                    v-model="model.buildingIdList"
                    :options="buildingOptions"
                    @change="buildingChange"
                    />
                </a-form-model-item>
            </a-col> -->

            <a-col :span="24">
                <a-form-model-item label="厂区-区域-楼栋" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="treeData">
                  <a-tree-select
                    style="width: 100%"
                    v-model="model.treeData"
                    :tree-data="treeData"
                    @treeExpand="handlerTreeExpand"
                    tree-checkable
                    allow-clear
                    :show-checked-strategy="SHOW_PARENT"
                    placeholder="请选择厂区-区域-楼栋"
                    @change="handlerChange"
                    @select="handlerSelect"
                  />
                </a-form-model-item>
           </a-col>

          <a-col :span="24">
            <a-form-model-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <j-switch v-model="model.status"  ></j-switch>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction,postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { TreeSelect } from 'ant-design-vue';


  const SHOW_PARENT = TreeSelect.SHOW_CHILD

  export default {
    name: 'PreWarnRuleForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           name: [
              { required: true, message: '请输入规则名称!'},
              { validator: (rule, value, callback) => validateDuplicateValue('pre_warn_rule', 'name', value, this.model.id,'0', callback)},
           ],
           detectionUnit: [
              { required: true, message: '请输入时间单位!'},
           ],
           warnType: [
              { required: true, message: '请输入预警类型!'},
           ],
           detectionTime: [
              { required: true, message: '请输入核酸时间配置!'},
              { pattern: /^[0-9]\d*$/, message: '请输入正整数!'},
           ],
           beforeWarnTime: [
              { required: true, message: '请输入提前预警时间!'},
           ],
           treeData: [
              { required: true, message: '请输入厂区-区域-楼栋!'},
          ],

           /* factoryIdList: [
              { required: true, message: '请输入厂区!'},
           ],
           areaIdList: [
              { required: true, message: '请输入区域!'},
           ],
           buildingIdList: [
              { required: true, message: '请输入楼栋!'},
           ], */

           status: [
              { required: true, message: '请输入是否启用!'},
           ],
        },
        url: {
          add: "/prevent/warn/add",
          edit: "/prevent/warn/edit",
          queryById: "/prevent/warn/queryById",
          tree: "/prevent/customer/treeList",
        },
        timeType : '小时',
        factoryOptions:[],
        areaOptions:[],
        buildingOptions:[],
        treeData:[],
        SHOW_PARENT
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));

      // this.initFactoryOptions();
      this.initTreeList();
    },
    methods: {
      
       detectionUnitChange(val){
         if(val=='小时'){
           this.timeType = '小时'
         }else if(val=='天'){
            this.timeType = '天'
         }
       },

       initTreeList(){
        getAction(this.url.tree).then(res=>{
          if(res.success){
            this.treeData = res.result;
            console.log('res.result:',res.result)
          }
        })
      },

      handlerTreeExpand(expandedKeys) {
        //console.log('handlerTreeExpand expandedKeys : ',expandedKeys)
      },

      handlerChange(value, label, extra) {
        console.log('handlerChange : ',value, label, extra)
        this.model.buildingIdList = value
        console.log('this.model.buildingIdList: ', this.model.buildingIdList);
      },

      handlerSelect(value, label, extra) {
       // console.log('handlerSelect  : ',value, label, extra)
      },

      /* initFactoryOptions(){
        getAction('/prevent/factory/prefactorys',{pageNo:1,pageSize:100000}).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.name, value: item.id}
              return c;
            })
            this.factoryOptions.unshift({label: '所有',value: '所有'});
			    }
        })

      },

      factoryChange(val){
        if(typeof val=='undefined'){
          this.areaOptions=[]
          this.buildingOptions=[]
          return;
			   }

         if(!this.model.id){ //新增
            console.log('1111111');
            this.$set(this.model,'areaIdList',[])
            this.$set(this.model,'buildingIdList',[])
         }
         //选择 所有 删除其他项
         let arr=val.filter(item => item == "所有")
         
         if(arr.length>0){//选择 所有
           this.factoryOptions.splice(1)
           let all= [{label: '所有',value: '所有'}]
           this.areaOptions = all;
           //赋值 厂区栏位
           this.model.factoryIdList =['所有']
           return
         }
         if(val.length==0){ //勾掉 所有
           this.initFactoryOptions()
         }

         let unAll = val.filter(item=>item!='所有')
         if(unAll.length>0){//选择 非所有

         }
         let factoryIds = val;
         postAction('/prevent/area/getAreaByFactoryId',factoryIds).then(res=>{
           if(res.success){
              this.areaOptions = res.result.map((item,index,arr)=>{
                let c = {label:item.name, value: item.id}
                return c;
              })
              this.$set(this.model,'factoryIdList',val)
              
			      }
         })
      },

      areaChange(val){
        if(typeof val=='undefined'){
          this.buildingOptions=[];
          return;
			   }
         if(!this.model.id){ //新增
            this.$set(this.model,'buildingIdList',[])
         }
         let arr=val.filter(item => item == "所有")
         if(arr.length>0){//选择 所有
           this.factoryOptions.splice(1)
           let all= [{label: '所有',value: '所有'}]

           this.buildingOptions =all;
           return
         }

         let areaIds = val;
         postAction('/prevent/building/getBuildingByAreaId',areaIds).then(res=>{
           if(res.success){
              this.buildingOptions = res.result.map((item,index,arr)=>{
                let c = {label:item.name, value: item.id}
                return c;
              })
              this.$set(this.model,'areaIdList',val)
			      }
         })

      },

      buildingChange(val){
        if(typeof val=='undefined'){
			     return;
			  }
        this.$set(this.model,'buildingIdList',val)
      }, */


      add () {
        // this.edit(this.modelDefault);

        this.visible = true;
      },
      edit (record) {
        // this.model = Object.assign({}, record);
        //详情查询
        getAction('/prevent/warn/queryById',{id:record.id}).then(res=>{
           if(res.success){
             this.model=res.result

             //回显 厂区 区域
             this.$set(this.model,'treeData',this.model.buildingIdList)
            //  this.factoryChange(this.model.factoryIdList);
            //  this.areaChange(this.model.areaIdList)
             //回显 单位
             this.detectionUnitChange(this.model.detectionUnit);

           }else{
             this.$message.warning(res.message);
           }
        })

        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
